import socials from '../../../../../data/socials.json';


import { Box, Button, List, ListItem, Typography } from "@mui/material";
import PhoneIcon from '@mui/icons-material/Phone';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import EmailIcon from '@mui/icons-material/Email';;


export default function ContactPage(){

    function handleCall(){
        window.location.href = `tel:${socials.tel}`;
    }

    function handleEmail(){
        window.location.href = `mailto:${socials.email}`;
    }

    function handleClick(to){
        window.open(to,'_blank');
    }

    return(
       <Box 
            sx={{
                mt:2
            }}
            display="flex"
            flexDirection="column"
            alignItems="center"
       >
            <Typography>Contact Us!</Typography>
            <List>
                {socials?.tel && 
                <ListItem>
                    <Button variant="contained" startIcon={<PhoneIcon />} onClick={handleCall}>{socials.tel}</Button>
                </ListItem>}

                {socials?.email && 
                <ListItem>
                    <Button variant="contained" startIcon={<EmailIcon />} onClick={handleEmail} sx={{textTransform:'none'}}>{socials.email}</Button>
                </ListItem>}

                {socials?.instagram &&
                <ListItem>
                    <Button variant="contained" startIcon={<InstagramIcon />} onClick={()=>handleClick(socials.instagram.url)} sx={{textTransform:'none'}}>{socials.instagram.handle}</Button>
                </ListItem>}

                {socials?.facebook &&
                <ListItem>
                    <Button variant="contained" startIcon={<FacebookIcon />} onClick={()=>handleClick(socials.facebook.url)} sx={{textTransform:'none'}}>{socials.facebook.pagename}</Button>
                </ListItem>}
            </List>
       </Box>
       );
}